// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://sepolia.basescan.org/address/0xE4C23309117Aa30342BFaae6c95c6478e0A4Ad00
export const POOL_ADDRESSES_PROVIDER = '0xE4C23309117Aa30342BFaae6c95c6478e0A4Ad00';

// IPool https://sepolia.basescan.org/address/0x8bAB6d1b75f19e9eD9fCe8b9BD338844fF79aE27
export const POOL = '0x8bAB6d1b75f19e9eD9fCe8b9BD338844fF79aE27';

// IPoolConfigurator https://sepolia.basescan.org/address/0x0Bf6bdFF4da24C272BC524d521Ab0db20601D384
export const POOL_CONFIGURATOR = '0x0Bf6bdFF4da24C272BC524d521Ab0db20601D384';

// IAaveOracle https://sepolia.basescan.org/address/0x943b0dE18d4abf4eF02A85912F8fc07684C141dF
export const ORACLE = '0x943b0dE18d4abf4eF02A85912F8fc07684C141dF';

// https://sepolia.basescan.org/address/0x956DE559DFc27678FD69d4f49f485196b50BDD0F
export const ACL_ADMIN = '0x956DE559DFc27678FD69d4f49f485196b50BDD0F';

// IACLManager https://sepolia.basescan.org/address/0x9f09F541Adf314341d8d45E5B18961147b9050E9
export const ACL_MANAGER = '0x9f09F541Adf314341d8d45E5B18961147b9050E9';

// IPoolDataProvider https://sepolia.basescan.org/address/0xBc9f5b7E248451CdD7cA54e717a2BFe1F32b566b
export const AAVE_PROTOCOL_DATA_PROVIDER = '0xBc9f5b7E248451CdD7cA54e717a2BFe1F32b566b';

// https://sepolia.basescan.org/address/0xE9fb54369E85b9714F9d86366D918c5C7C87783A
export const POOL_IMPL = '0xE9fb54369E85b9714F9d86366D918c5C7C87783A';

// https://sepolia.basescan.org/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://sepolia.basescan.org/address/0x71B448405c803A3982aBa448133133D2DEAFBE5F
export const DEFAULT_INCENTIVES_CONTROLLER = '0x71B448405c803A3982aBa448133133D2DEAFBE5F';

// https://sepolia.basescan.org/address/0x49ECA4d8e7EaE6a1e7c02516851fF9038b277e96
export const EMISSION_MANAGER = '0x49ECA4d8e7EaE6a1e7c02516851fF9038b277e96';

// ICollector https://sepolia.basescan.org/address/0x6414DE3F58d54Fb90636e8393F065fDFe34Da420
export const COLLECTOR = '0x6414DE3F58d54Fb90636e8393F065fDFe34Da420';

// https://sepolia.basescan.org/address/0xF83D6A049FE62b8A1270525E1516F93b61C7D113
export const DEFAULT_A_TOKEN_IMPL = '0xF83D6A049FE62b8A1270525E1516F93b61C7D113';

// https://sepolia.basescan.org/address/0x1A91BEfb27d0DB4FDE68D28bf0cbdD5BC9C5FdF2
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0x1A91BEfb27d0DB4FDE68D28bf0cbdD5BC9C5FdF2';

// https://sepolia.basescan.org/address/0x4Afb5ADe7Bd7a670B61f303ab0C740eE8350918f
export const STATA_FACTORY = '0x4Afb5ADe7Bd7a670B61f303ab0C740eE8350918f';

// https://sepolia.basescan.org/address/0xD3a3f523100e1eaa740A6eE72Ae94710A0fAcFCe
export const CONFIG_ENGINE = '0xD3a3f523100e1eaa740A6eE72Ae94710A0fAcFCe';

// https://sepolia.basescan.org/address/0x8eB0791E0981947df2eA074D2479dB9A258b0312
export const L2_ENCODER = '0x8eB0791E0981947df2eA074D2479dB9A258b0312';

// https://sepolia.basescan.org/address/0x34473a6Ef69d92191d7b25352b5D266f3a5BAca2
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x34473a6Ef69d92191d7b25352b5D266f3a5BAca2';

// https://sepolia.basescan.org/address/0xDB1412acf288D5bE057f8e90fd7b1BF4f84bB3B1
export const UI_INCENTIVE_DATA_PROVIDER = '0xDB1412acf288D5bE057f8e90fd7b1BF4f84bB3B1';

// https://sepolia.basescan.org/address/0x6a9D64f93DB660EaCB2b6E9424792c630CdA87d8
export const UI_POOL_DATA_PROVIDER = '0x6a9D64f93DB660EaCB2b6E9424792c630CdA87d8';

// https://sepolia.basescan.org/address/0x2c4D1F4EC7F4FfA09a5E1C9e74fD3A10f21Bd811
export const WALLET_BALANCE_PROVIDER = '0x2c4D1F4EC7F4FfA09a5E1C9e74fD3A10f21Bd811';

// https://sepolia.basescan.org/address/0x0568130e794429D2eEBC4dafE18f25Ff1a1ed8b6
export const WETH_GATEWAY = '0x0568130e794429D2eEBC4dafE18f25Ff1a1ed8b6';

export const CHAIN_ID = 84532;
export const ASSETS = {
  USDC: {
    decimals: 6,
    id: 0,
    UNDERLYING: '0xba50Cd2A20f6DA35D788639E581bca8d0B5d4D5f',
    A_TOKEN: '0x10F1A9D11CDf50041f3f8cB7191CBE2f31750ACC',
    V_TOKEN: '0xFB3e85601b7fEb3691bbb8779Ef0E1069E347204',
    INTEREST_RATE_STRATEGY: '0x705F7D9Ed0Ac3724eC974DaF6A099bA59d254b92',
    ORACLE: '0xd30e2101a97dcbAeBCBC04F14C3f624E67A35165',
    STATA_TOKEN: '0xf430cb6E2b85f99222fBFA6dFEa18Ff60FA6B32a',
  },
  USDT: {
    decimals: 6,
    id: 1,
    UNDERLYING: '0x0a215D8ba66387DCA84B284D18c3B4ec3de6E54a',
    A_TOKEN: '0xcE3CAae5Ed17A7AafCEEbc897DE843fA6CC0c018',
    V_TOKEN: '0xE3C742c88EE6A610157C16b60bBDD62351daeE39',
    INTEREST_RATE_STRATEGY: '0x705F7D9Ed0Ac3724eC974DaF6A099bA59d254b92',
    ORACLE: '0x3ec8593F930EA45ea58c968260e6e9FF53FC934f',
    STATA_TOKEN: '0xf63dA51069FAe9448747FA425F8Cb84B0149eC0F',
  },
  WBTC: {
    decimals: 8,
    id: 2,
    UNDERLYING: '0x54114591963CF60EF3aA63bEfD6eC263D98145a4',
    A_TOKEN: '0x47Db195BAf46898302C06c31bCF46c01C64ACcF9',
    V_TOKEN: '0x638291B5Ccb9fEd339FdD351Eb086e607fCA9561',
    INTEREST_RATE_STRATEGY: '0x705F7D9Ed0Ac3724eC974DaF6A099bA59d254b92',
    ORACLE: '0x0FB99723Aee6f420beAD13e6bBB79b7E6F034298',
    STATA_TOKEN: '0x5d7538579560F5fdD54F9D264DBe0e697b5BF668',
  },
  WETH: {
    decimals: 18,
    id: 3,
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    A_TOKEN: '0x73a5bB60b0B0fc35710DDc0ea9c407031E31Bdbb',
    V_TOKEN: '0x562abf6562d6A2b165aDa02b5946bc3E7b4dD653',
    INTEREST_RATE_STRATEGY: '0x705F7D9Ed0Ac3724eC974DaF6A099bA59d254b92',
    ORACLE: '0x4aDC67696bA383F43DD60A9e78F2C97Fbbfc7cb1',
    STATA_TOKEN: '0xde7820fFb73059608928cb9e29F6EB1369Ad1342',
  },
  cbETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xD171b9694f7A2597Ed006D41f7509aaD4B485c4B',
    A_TOKEN: '0x9Fd6d1DBAd7c052e0c43f46df36eEc6a68814B63',
    V_TOKEN: '0xa1a483652b157FF006292CDb0e9EB7FFad2a5142',
    INTEREST_RATE_STRATEGY: '0x705F7D9Ed0Ac3724eC974DaF6A099bA59d254b92',
    ORACLE: '0x3c65e28D357a37589e1C7C86044a9f44dDC17134',
    STATA_TOKEN: '0x9F56ff6c3441bb89eBFf1c0bc75D4096C33230d1',
  },
  LINK: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x810D46F9a9027E28F9B01F75E2bdde839dA61115',
    A_TOKEN: '0x0aD46dE765522399d7b25B438b230A894d72272B',
    V_TOKEN: '0xBA42C6752F347e3c22DD0A4e5578dCB0137C1325',
    INTEREST_RATE_STRATEGY: '0x705F7D9Ed0Ac3724eC974DaF6A099bA59d254b92',
    ORACLE: '0xb113F5A928BCfF189C998ab20d753a47F9dE5A61',
    STATA_TOKEN: '0xFb3AB5ABd3dE4703C0F296B1fe6f5E570e1631Ff',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'WETH,cbETH / WETH,cbETH',
    collateralBitmap: '24',
    collateralAssets: [
      '0x4200000000000000000000000000000000000006',
      '0xD171b9694f7A2597Ed006D41f7509aaD4B485c4B',
    ],
    borrowableBitmap: '24',
    borrowableAssets: [
      '0x4200000000000000000000000000000000000006',
      '0xD171b9694f7A2597Ed006D41f7509aaD4B485c4B',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10250,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
